import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['banner', 'button']


  connect() {
    this.print()
  }
}